module.exports = __webpack_public_path__ + "static/media/red-chip.ed7aad20.svg";